export function getMessageByLanguage(errorMessages, language) {
    if (!errorMessages || errorMessages.length === 0) {
        return 'Erro desconhecido';
    }
    const messageByLanguage = errorMessages.find(msg => msg.language === language);
    if (messageByLanguage) {
        return messageByLanguage.message;
    }
    const defaultMessage = errorMessages.find(msg => msg.language === 'DEFAULT');
    if (defaultMessage) {
        return defaultMessage.message;
    }
    return errorMessages[0].message;
}
export function getErrorMapping(dictionary, channel, errorCode) {
    const channelErrors = dictionary[channel];
    if (channelErrors?.[errorCode]) {
        return channelErrors[errorCode];
    }
    if (dictionary['DEFAULT']?.[errorCode]) {
        return dictionary['DEFAULT'][errorCode];
    }
    console.warn(`[ExceptionHandler] Unmapped error - Channel: ${channel}, Code: ${errorCode}`);
    return createGenericError(channel, errorCode);
}
export function interpolateMessage(message, variables) {
    if (!variables)
        return message;
    return message.replace(/\{\{(\w+)\}\}/g, (match, variableName) => {
        const value = variables[variableName];
        return value !== undefined ? String(value) : match;
    });
}
function isCodeLikeString(value) {
    return /^[A-Z0-9_-]+$/.test(value);
}
function extractCodeFromObject(obj) {
    if (obj.errorCode && typeof obj.errorCode === 'string') {
        return obj.errorCode;
    }
    if (obj.code && typeof obj.code === 'string') {
        return obj.code;
    }
    if (obj.error && typeof obj.error === 'string') {
        return obj.error;
    }
    if (obj.payload && typeof obj.payload === 'object') {
        return extractCodeFromObject(obj.payload);
    }
    if (obj.result) {
        return extractCodeFromResult(obj.result);
    }
    return null;
}
function extractCodeFromResult(result) {
    if (typeof result === 'string') {
        return isCodeLikeString(result) ? result : null;
    }
    if (!result || typeof result !== 'object') {
        return null;
    }
    return extractCodeFromObject(result);
}
function extractCodeFromDetails(details) {
    if (!details || typeof details !== 'object') {
        return null;
    }
    const detailsObj = details;
    if (detailsObj.payload && typeof detailsObj.payload === 'object') {
        const code = extractCodeFromObject(detailsObj.payload);
        if (code) {
            return code;
        }
    }
    return extractCodeFromResult(detailsObj.result);
}
function extractCodeFromResponse(response) {
    if (!response || typeof response !== 'object') {
        return null;
    }
    const responseObj = response;
    if (responseObj.data && typeof responseObj.data === 'object') {
        return extractCodeFromObject(responseObj.data);
    }
    return null;
}
export function extractErrorCode(error) {
    if (!error || typeof error !== 'object') {
        return null;
    }
    const errorObj = error;
    const resultCode = extractCodeFromResult(errorObj.result);
    if (resultCode) {
        return resultCode;
    }
    const detailsCode = extractCodeFromDetails(errorObj.details);
    if (detailsCode) {
        return detailsCode;
    }
    if (errorObj.data && typeof errorObj.data === 'object') {
        const dataCode = extractCodeFromObject(errorObj.data);
        if (dataCode) {
            return dataCode;
        }
    }
    const directCode = extractCodeFromObject(errorObj);
    if (directCode) {
        return directCode;
    }
    const responseCode = extractCodeFromResponse(errorObj.response);
    if (responseCode) {
        return responseCode;
    }
    if (errorObj.status && typeof errorObj.status === 'number') {
        return `HTTP_${errorObj.status}`;
    }
    return null;
}
function createGenericError(channel, errorCode) {
    const genericMessages = [
        {
            language: 'DEFAULT',
            message: channel === 'SUPERAPP' ? 'Ops! Algo deu errado.' : 'Ocorreu um erro inesperado.',
        },
        {
            language: 'en-US',
            message: 'An unexpected error occurred.',
        },
        {
            language: 'es-ES',
            message: 'Ocurrió un error inesperado.',
        },
        {
            language: 'pt-BR',
            message: 'Ocorreu um erro inesperado.',
        },
    ];
    return {
        code: 'UNKNOWN_ERROR',
        channel,
        domain: 'sistema',
        userMessage: genericMessages,
        technicalMessage: `Unmapped error - Channel: ${channel}, Code: ${errorCode}`,
        severity: 'error',
        critical: false,
        metadata: {
            shouldReport: true,
            originalChannel: channel,
            originalCode: errorCode,
        },
    };
}
